import { useEffect, useState } from "react";
import "./App.css";
import { ReactComponent as Arrow } from "./assets/chevron.svg";
import Header from "./Header";
import questions from "./assets/constance";

function App() {
  const [step, setStep] = useState(0);
  const [answer, setAnswer] = useState({
    step1: "",
    step2: "",
    step3: "",
    step4: "",
    step5: "",
    step6: ""
  });
  const [isMobile, setIsMobile] = useState(false);

  const setAnswerHandler = (step, item) => {
    setAnswer({
      ...answer,
      ["step" + step]: item
    });
    setStep(step + 1);
  };

  const handleMovePurchase = (path) => {
    window.open(path);
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.body.style.backgroundImage = "none";
    document.body.style.backgroundColor = "#d9dad6";
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  return (
    <div className="app">
      {step === 0 ? (
        <main>
          <h1>오늘을 위한 당신의 센트</h1>
          <p className="first-text">
            오늘, 당신의 기분은 어떤가요?
            <br />
            오늘은 당신에게 특별한 날인가요?
            <br />
            혹은 일상의 기쁨을 느끼고 싶은 날인가요?
            <br />
            <br />
            로에가 제안하는 오늘의 향기로
            <br />
            당신을 초대합니다.
          </p>
          <button className="nextbtn" onClick={() => setStep(1)}>
            <img src="/images/start.png" alt="start-button" />
          </button>
          <p className="first-text" style={{ paddingBottom: 60 }}>
            향기를 선택하는 것은 어렵지 않습니다.
            <br />
            헤드노트, 하트노트, 소울노트의 한 개 한 개 원료를
            <br />
            아는 것은 중요하지 않습니다.
            <br />
            당신이 끌리는 향기, 당신이 좋아하는 향기에
            <br />
            당신을 맡기세요.
            <br />
            <br />
            편안한 로에의 향기로
            <br />
            일상의 하루를 향기롭고 기분 좋게 보내세요.
          </p>
        </main>
      ) : step === 1 ? (
        <main>
          <h1>당신의 투데이 센트</h1>
          <p className="second-text">
            로에의 투데이 센트와 함께,
            <br />
            오늘의 당신의 향기를 찾아보세요.
            <br />
            <br />
            간단한 질문으로,
            <br />
            오늘 당신에게 어울리는 향기를 추천드려요.
            <br />
            향기의 세계와 단어를 탐험하고,
            <br />
            로에가 제안하는 향기를 만나보세요.
            <br />
          </p>
          <button className="nextbtn-second" onClick={() => setStep(2)}>
            <img src="/images/start.png" alt="start-button" />
          </button>
          <img src="/images/2.png" alt="second-img" className="second-img" />
        </main>
      ) : step <= 4 ? (
        <main className="second-container">
          <Header step={step} setStep={setStep} setAnswer={setAnswerHandler} />
          <div className="second-question">
            {(step === 2 || step === 4) && (
              <img
                src="/images/f1.png"
                alt="second-img"
                className="top-flower"
              />
            )}
            {step === 4 && (
              <img
                src="/images/f4.png"
                alt="second-img"
                className="top-under"
              />
            )}
            <div>
              <img
                src="/images/greentip.png"
                alt="second-img"
                className="second-img-tip"
              />
              <span className="second-question-text">
                {questions[step - 1].question}
              </span>
            </div>
          </div>
          <div className="second-answer">
            {questions[step - 1].answers.map((item, index) => {
              return (
                <li
                  key={`${step}-${index}`}
                  onClick={() => setAnswerHandler(step, item)}
                  style={{
                    animation: `fadeInUp ${index + 0.5}s ease-in-out forwards`,
                    backgroundColor:
                      step === 2
                        ? "#fdfbf1"
                        : step === 3
                        ? "#fcece8"
                        : step === 4
                        ? "#f5f1f8"
                        : "#f3f3ee",
                    marginBottom: isMobile
                      ? 15
                      : step === 3 || step === 4
                      ? 40
                      : 15
                  }}
                >
                  {item}
                  <Arrow
                    width="22px"
                    height="25px"
                    style={{ position: "absolute", right: 10, top: 11 }}
                  />
                  <img
                    src={`/images/${
                      step === 2
                        ? "bagtip"
                        : step === 3
                        ? "pinktip"
                        : step === 4
                        ? "boratip"
                        : "bag6tip"
                    }.png`}
                    alt="second-img"
                    className="second-img-btip"
                    style={{
                    }}
                  />
                </li>
              );
            })}
            {step === 3 && (
              <img
                src="/images/f2.png"
                alt="second-img"
                style={{
                  width: 140,
                  height: 140,
                  marginTop: 50,
                  alignSelf: "start"
                }}
              />
            )}
          </div>
        </main>
      ) : step === 5 ? (
        <main className="second-container">
          <Header step={step} setStep={setStep} setAnswer={setAnswerHandler} />
          <div className="second-question">
            <img
              src="/images/f5.png"
              alt="second-img"
              className="top-flower"
              style={{ left: 60 }}
            />
            <div>
              <img
                src="/images/greentip.png"
                alt="second-img"
                className="second-img-tip"
                
              />
              <span className="second-question-text" style={{letterSpacing: '-0.8px'}}>
                {questions[step - 1].question}
              </span>
            </div>
            {step === 9 && (
              <img
                src="/images/f9.png"
                alt="second-img"
                className="top-under"
                style={{ left: 100 }}
              />
            )}
          </div>
          <div className="second-answer">
            {questions[step - 1].answers.map((item, index) => {
              return (
                <li
                  key={`${step}-${index}`}
                  onClick={() => setAnswerHandler(step, item)}
                  style={{
                    animation: `fadeInUp ${index + 0.5}s ease-in-out forwards`,
                    backgroundColor: "#f3f3ee",
                    marginBottom: isMobile ? 15 : 30
                  }}
                >
                  {item.q}
                  <Arrow
                    width="22px"
                    height="25px"
                    style={{ position: "absolute", right: 10, top: 11 }}
                  />
                  <img
                    src={`/images/bag6tip.png`}
                    alt="second-img"
                    className="second-img-btip"
                  />
                </li>
              );
            })}
          </div>
        </main>
      ) : step === 6 ? (
        <main className="second-container">
          <Header step={step} setStep={setStep} setAnswer={setAnswerHandler} />
          <div className="second-question">
            <div>
              <img
                src="/images/greentip.png"
                alt="second-img"
                className="second-img-tip"
              />
              <span className="second-question-text" style={{letterSpacing: '-0.8px'}}>
                {answer.step5.a.question}
              </span>
            </div>
          </div>
          <div className="second-answer">
            {answer.step5.a.options.map((item, index) => {
              return (
                <li
                  key={`${step}-${index}`}
                  onClick={() => setAnswerHandler(step, item)}
                  style={{
                    animation: `fadeInUp ${index + 0.5}s ease-in-out forwards`,
                    backgroundColor: "#f3f3ee",
                    marginBottom: 15
                  }}
                >
                  {item.select}
                  <Arrow
                    width="22px"
                    height="25px"
                    style={{ position: "absolute", right: 10, top: 11 }}
                  />
                  <img
                    src="/images/bag6tip.png"
                    alt="second-img"
                    className="second-img-btip"
                  />
                </li>
              );
            })}
            <img
              src="/images/f6.png"
              alt="second-img"
              className="step-seven-img01"
            />
            <img
              src="/images/f7.png"
              alt="second-img"
              className="step-seven-img02"
            />
          </div>
        </main>
      ) : (
        <main
          style={{
            padding: isMobile ? 0 : null,
            height: isMobile ? "100%" : "1100px",
            justifyContent: "flex-start"
          }}
        >
          <img
            src={`/images/${answer.step6.result}.png`}
            alt="result"
            style={{ width: "100%", height: "auto" }}
          />
          <div className="result-bottom">
            <h3>{answer.step6.tag}</h3>
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              {answer.step6.text.map((item) => (
                <p className="result-text-explain">{item}</p>
              ))}
            </div>
            <button
              className="nextbtn-second"
              onClick={() => handleMovePurchase(answer.step6.path)}
            >
              <img src="/images/buy.png" alt="start-button" />
            </button>
            <p
              className="result-text"
              style={{ marginBottom: 40, cursor: "pointer" }}
              onClick={() => setStep(0)}
            >
              다시하기
            </p>
          </div>
        </main>
      )}
    </div>
  );
}

export default App;
